import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { TranslationMemoryDestroyInput, TranslationMemoryDestroyPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = TranslationMemoryDestroyInput;
type TData = TranslationMemoryDestroyPayload;

export const useTranslationMemoryDestroy = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation translationMemoryDestroy($input: TranslationMemoryDestroyInput!) {
      translationMemoryDestroy(input: $input) {
        success
        errors
        errorCode
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
